import * as React from 'react';
import { SVGProps } from 'react';
const SvgHamburgerIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 20 20" {...props}>
    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3.125 5.625h13.75M3.125 10h13.75m-13.75 4.375h13.75" />
  </svg>
);
export default SvgHamburgerIcon;
